import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "split-table-layout" }
const _hoisted_15 = {
  key: 0,
  href: "javascript:void(0);",
  class: "mr-10",
  style: {"color":"green"}
}
const _hoisted_16 = {
  key: 1,
  href: "javascript:void(0);",
  class: "mr-10",
  style: {"color":"#999"}
}
const _hoisted_17 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_18 = { class: "tab-title_left fl" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_PriceInfo = _resolveComponent("PriceInfo")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_PurchaseForm = _resolveComponent("PurchaseForm")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "材料编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.materialNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: ""
                }, null, 8, ["modelValue", "size"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "材料品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialBrand,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.materialBrand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: ""
                }, null, 8, ["modelValue", "size"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "材料名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.materialName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: ""
                }, null, 8, ["modelValue", "size"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "材料型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialModel,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.materialModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: ""
                }, null, 8, ["modelValue", "size"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "材料代码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialCode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.materialCode) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: ""
                }, null, 8, ["modelValue", "size"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "申请人", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.createUser,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.createUser) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleCreateUserFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createUserOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.status,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.status) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('purchase')))
          }, {
            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
              _createTextVNode(" 生成采购单 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleBatchUpdate
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode(" 批量编辑 ", -1)
            ]))]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleBatchReturn
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode(" 退回预采购信息 ", -1)
            ]))]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_RETRUN` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[34] || (_cache[34] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: rf => { if (rf) _ctx.tableDataRef[0] = rf },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            tableRowClassName: _ctx.tableRowClassName,
            showSelection: true,
            showSummary: true,
            isShowPagination: false,
            handleDefaultWidth: 120,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            style: {"height":"calc(100% )","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            max: _withCtx((scope) => [
              _createElementVNode("span", null, [
                (scope.row.material?.max)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      placement: "top-start"
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.material?.max?.supplier?.name), 1),
                        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.material?.max?.updateTime), 1)
                      ]),
                      default: _withCtx(() => [
                        _cache[36] || (_cache[36] = _createElementVNode("i", {
                          class: "iconfont icon-tubiao-30",
                          style: {"font-size":"14px"}
                        }, null, -1))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row.material, 'max')), 1)
              ])
            ]),
            min: _withCtx((scope) => [
              _createElementVNode("span", null, [
                (scope.row.material?.min)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      placement: "top-start"
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.material?.min?.supplier?.name), 1),
                        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.material?.min?.updateTime), 1)
                      ]),
                      default: _withCtx(() => [
                        _cache[38] || (_cache[38] = _createElementVNode("i", {
                          class: "iconfont icon-tubiao-30",
                          style: {"font-size":"14px"}
                        }, null, -1))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row.material, 'min')), 1)
              ])
            ]),
            "operation-action": _withCtx((scope) => [
              (scope.row.status === '待处理')
                ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    href: "javascript:void(0);",
                    class: "mr-10",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode(" 编辑 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
                  ])
                : _createCommentVNode("", true),
              (scope.row.status !== '待处理')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (scope.row.status !== '采购拒绝')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, " 已拒绝 "))
                  ], 64))
                : _createCommentVNode("", true),
              (scope.row.status === '采购拒绝')
                ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                    key: 2,
                    href: "javascript:void(0);",
                    class: "mr-10",
                    type: "danger",
                    onClick: ($event: any) => (_ctx.handleCommand('delete', scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode(" 删除 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_permission, { pkey: `${_ctx.permissionName}_DELETE` }]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "tableRowClassName", "newHpx", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_19))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_PriceInfo, {
                key: 0,
                ref: "PriceInfo",
                id: _ctx.activeMaterialId,
                formPage: "material",
                dataId: _ctx.activeId,
                materialInfo: _ctx.materialInfo
              }, null, 8, ["id", "dataId", "materialInfo"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible & !_ctx.purchaseFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          selectRows: _ctx.selectRows,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'purchaseInAdvance',
          isEdit: _ctx.isEdit,
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[16] || (_cache[16] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["initFormData", "fromFieldData", "selectRows", "dialogFormVisible", "isEdit", "commandState"]))
      : _createCommentVNode("", true),
    (_ctx.purchaseFormVisible)
      ? (_openBlock(), _createBlock(_component_PurchaseForm, {
          key: 1,
          dialogFormVisible: _ctx.purchaseFormVisible,
          api: 'purchase',
          selectionArray: _ctx.selectionArray,
          "onUpdate:visibel": _cache[18] || (_cache[18] = () => _ctx.purchaseFormVisible = false),
          onSubmit: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSubmit()))
        }, null, 8, ["dialogFormVisible", "selectionArray"]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible && !_ctx.purchaseFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}